exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".material-icons.md-12[data-v-6111b4f6]{font-size:12px}.material-icons.md-light[data-v-6111b4f6]{color:#fff}.material-icons.md-light.md-inactive[data-v-6111b4f6]{color:rgba(255,255,255,.3)}#mxr-cta-instacart a[data-v-6111b4f6]{background-color:#68bf54}#mxr-cta-instacart a[data-v-6111b4f6]:hover{background-color:#43b02a}", ""]);

